module.exports = __webpack_public_path__ + "static/img/fute.ff6a2931.png";